module.exports = __webpack_public_path__ + "img/copy.df0b00b7.svg";